<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-content>
        <v-toolbar class="content-toolbar">
            <v-btn flat class="back-button" @click="$router.go(-1)">
                <font-awesome-icon :icon="['far', 'chevron-left']" size="2x"/>
            </v-btn>
            <font-awesome-icon v-if="isEditMode" :icon="['fal', 'edit']" size="2x"/>
            <font-awesome-icon v-else :icon="['fal', 'pencil-alt']" size="2x"/>
            <v-toolbar-title>{{title}}</v-toolbar-title>

        </v-toolbar>

        <div class="content-container">
            <div class="form-container">
                <v-container fill-height class="fields-container">
                    <v-layout>
                        <v-flex>
                            <v-progress-linear v-if="isLoading" indeterminate color="secondary"></v-progress-linear>
                            <template v-else>
                                <div v-if="contentType">
                                    <v-form>
                                        <div v-for="datum in mappedFields"
                                             v-bind:data="datum.field"
                                             v-bind:key="datum.field.identifier">
                                            <template v-if="datum.formModelFieldRef">
                                                <div v-if="datum.isTypeShortText" class="field-container-1">
                                                    <sfr-text-short-field :field="datum.field"
                                                                          :valid="datum.formModelFieldRef.valid"
                                                                          v-on:sfr:validation-state="datum.onValidationStateChange"
                                                                          v-on:sfr:touched="touchState"
                                                                          v-model="datum.formModelFieldRef.value">
                                                    </sfr-text-short-field>
                                                </div>
                                                <div v-else-if="datum.isTypeLongText"
                                                     class="field-container-1">
                                                    <sfr-text-long-field :field="datum.field"
                                                                         :valid="datum.formModelFieldRef.valid"
                                                                         v-on:sfr:validation-state="datum.onValidationStateChange"
                                                                         v-on:sfr:touched="touchState"
                                                                         v-model="datum.formModelFieldRef.value">
                                                    </sfr-text-long-field>
                                                </div>
                                                <div v-else-if="datum.isTypeBoolean"
                                                     class="field-container-1">
                                                    <sfr-boolean-field :field="datum.field"
                                                                       v-on:sfr:touched="touchState"
                                                                       v-model="datum.formModelFieldRef.value">
                                                    </sfr-boolean-field>
                                                </div>
                                                <div v-else-if="datum.isTypeNumber"
                                                     class="field-container-1">
                                                    <sfr-number-field :field="datum.field"
                                                                      :valid="datum.formModelFieldRef.valid"
                                                                      v-on:sfr:validation-state="datum.onValidationStateChange"
                                                                      v-on:sfr:touched="touchState"
                                                                      v-model="datum.formModelFieldRef.value">
                                                    </sfr-number-field>
                                                </div>
                                                <div v-else-if="datum.isTypeDatetime"
                                                     class="field-container-1">
                                                    <sfr-datetime-field :field="datum.field"
                                                                        :valid="datum.formModelFieldRef.valid"
                                                                        v-on:sfr:validation-state="datum.onValidationStateChange"
                                                                        v-on:sfr:touched="touchState"
                                                                        v-model="datum.formModelFieldRef.value">
                                                    </sfr-datetime-field>
                                                </div>
                                                <div v-else-if="datum.isTypeLocation"
                                                     class="field-container-1">
                                                    <sfr-location-field :field="datum.field"
                                                                        :valid="datum.formModelFieldRef.valid"
                                                                        v-on:sfr:validation-state="datum.onValidationStateChange"
                                                                        v-on:sfr:touched="touchState"
                                                                        v-model="datum.formModelFieldRef.value">
                                                    </sfr-location-field>

                                                </div>
                                                <div v-else-if="datum.isTypeReference"
                                                     class="field-container-1">
                                                    <sfr-reference-field :field="datum.field"
                                                                         :valid="datum.formModelFieldRef.valid"
                                                                         v-on:sfr:validation-state="datum.onValidationStateChange"
                                                                         v-on:sfr:touched="touchState"
                                                                         v-on:sfr:nested-creation="pushNestedCreationObjectAndNavigate"
                                                                         v-model="datum.formModelFieldRef.value">
                                                    </sfr-reference-field>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="field-container-1">
                                            <sfr-file-selection-field ref="file-selector"
                                                                      :existing-asset="existingAsset"
                                                                      v-on:sfr:file-selected="onFileInputChange"
                                                                      v-on:sfr:touched="touchState">
                                            </sfr-file-selection-field>
                                        </div>
                                        <div v-if="isMediaPipelineEnabled">
                                            <div>
                                                <v-expansion-panel v-model="expandedIdx">
                                                    <v-expansion-panel-content v-if="isTrimUIShowing">
                                                        <template slot="header">
                                                            <div>
                                                                <span>Trim start and end</span>
                                                            </div>
                                                        </template>
                                                        <v-card>
                                                            <div class="trim-ui">
                                                                <div>
                                                                    <v-text-field type="number" color="accent"
                                                                                  persistent-hint
                                                                                  hint="Trim from the beginning (seconds)"
                                                                                  v-model="trimData.start"
                                                                                  min="0"
                                                                                  @input="touchState"
                                                                    ></v-text-field>
                                                                </div>
                                                                <div>
                                                                    <v-text-field type="number" color="accent"
                                                                                  persistent-hint
                                                                                  hint="Trim from the end (seconds)"
                                                                                  v-model="trimData.end"
                                                                                  min="0"
                                                                                  @input="touchState"
                                                                    ></v-text-field>
                                                                </div>
                                                            </div>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-content v-if="isStitchingUIShowing">
                                                        <template slot="header">
                                                            <div>
                                                                <span>Stitch multiple clips</span>
                                                            </div>
                                                        </template>
                                                        <v-card>
                                                            <div class="stitch-ui">
                                                                <sfr-file-selection-field
                                                                        ref="stitching-file-selector"
                                                                        allowsMultiple stitch
                                                                        :accepts="inputAcceptsArray"
                                                                        :selected-files="stitchingData.selectedFiles"
                                                                        @sfr:file-selected="onStitchingUIFileInputChange">
                                                                </sfr-file-selection-field>
                                                            </div>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </div>
                                        </div>
                                    </v-form>
                                </div>
                            </template>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
            <div class="crud-sidebar-container">
                <v-navigation-drawer permanent class="crud-sidebar">
                    <div>
                        <template v-if="isEditMode">
                            <v-subheader>Status</v-subheader>
                            <v-divider></v-divider>
                            <div v-if="isFormPopulated" class="right-side-bar">
                        <span v-if="status"><font-awesome-icon :icon="['fas', 'circle']" class="icon-status"
                                                               v-bind:class="statusCssString"/></span>
                                <span>Status: </span>
                                <span class="capitalize-text">{{status}}</span>
                                <div>
                                    <v-btn v-if="isStatusNotPublished" block color="success"
                                           @click="onPublishButtonClick" :loading="isStatusPublishLoading"
                                           :disabled="isPublishButtonDisabled">
                                        <span class="capitalize-text">publish</span>
                                    </v-btn>
                                    <v-btn v-if="isStatusNotDraft" block color="warning" @click="onDraftButtonClick"
                                           :loading="isStatusDraftLoading" :disabled="isDraftButtonDisabled">
                                        <span class="capitalize-text">revert to draft</span>
                                    </v-btn>
                                    <v-btn v-if="isStatusNotArchive" block color="error" @click="onArchiveButtonClick"
                                           :loading="isStatusArchiveLoading" :disabled="isArchiveButtonDisabled">
                                        <span class="capitalize-text">archive</span>
                                    </v-btn>
                                </div>
                            </div>
                        </template>
                        <template>
                            <v-subheader>Actions</v-subheader>
                            <v-divider></v-divider>
                            <div class="right-side-bar">
                                <div>
                                    <v-btn v-if="isEditMode" block color="info" @click="updateEntry()"
                                           :loading="isUpdateLoadingStateLoading" :disabled="isUpdateButtonDisabled">
                                        <span class="capitalize-text">Update</span>
                                        <v-progress-circular v-if="isUpdateProgressCompleted" slot="loader"
                                                             :value="updateLoadingState.progress" :width="3"
                                                             :rotate="-90"></v-progress-circular>
                                        <v-progress-circular v-else slot="loader" indeterminate
                                                             :width="3"></v-progress-circular>
                                    </v-btn>
                                    <v-btn v-else block color="info"
                                           v-on:click="onAddAssetClick" :loading="isAddLoadingStateLoading"
                                           :disabled="isAddButtonDisabled">
                                        <span class="capitalize-text">Add Asset</span>
                                        <v-progress-circular v-if="isAddProgressCompleted" slot="loader"
                                                             :value="createAssetProgress" :width="3"
                                                             :rotate="-90"></v-progress-circular>
                                        <v-progress-circular v-else slot="loader" indeterminate
                                                             :width="3"></v-progress-circular>
                                    </v-btn>
                                </div>
                            </div>
                        </template>
                    </div>

                </v-navigation-drawer>
            </div>
        </div>
        <v-snackbar
                :timeout="snackBar.timeout"
                :bottom="true"
                v-model="snackBar.isShowing"
                :color="snackBar.color">
            {{ snackBar.text }}
            <v-btn dark flat @click.native="snackBar.isShowing = false">Ok</v-btn>
        </v-snackbar>
    </v-content>

</template>

<script>
    import http from '../services/axios'
    import lodash from '../services/lodash'
    import {
        TYPE_TEXT_SHORT,
        TYPE_TEXT_LONG,
        TYPE_BOOLEAN,
        TYPE_NUMBER,
        TYPE_DATETIME,
        TYPE_LOCATION,
        TYPE_REFERENCE,
        CONTENT_TYPE_ASSET,
        R_NAME_EDIT_MEDIA,
        R_NAME_ADD_ENTRY,
        LOAD_SPACE_CONTENT,
        LOADING_COMPLETED_FAILURE,
        LOADING_COMPLETED_SUCCESS,
        LOADING_PRISTINE,
        LOADING_STARTED,
        DRAFT_TEXT,
        PUBLISHED_TEXT,
        ARCHIVED_TEXT,
        PUSH_NESTED_CREATION_OBJECT,
        GET_NESTED_CREATION_STACK_TOP,
        REMOVE_NESTED_CREATION_STACK_TOP,
        SET_REFERENCE_NESTED_CREATION_OBJECT_STACK_TOP,
        SNACKBAR_COLOR_SUCCESS,
        SNACKBAR_COLOR_INFO,
        SNACKBAR_COLOR_ERROR,
        ASSET_CATEGORY_IMAGE,
        ASSET_CATEGORY_AUDIO,
        ASSET_CATEGORY_PDF,
        ASSET_CATEGORY_VIDEO,
        A_TRIM_ASSET,
        A_ARCHIVE_ASSET,
        A_CREATE_ASSET, A_STITCH_ASSETS,
    } from "../services/constants"
    import helpers, {convertToOutgoingEntry, mediaRefConstructor} from '../services/helpers'

    const trimDataConstructor = () => {
        return {
            start: '0',
            end: '0',
        }
    }

    const stitchDataConstructor = () => {
        return {
            selectedFiles: [],
        }
    }
    export default {
        name: 'space-dashboard-crud-media',
        data() {
            return {
                assetsContentType: 'asset',
                existingAsset: null,
                status: PUBLISHED_TEXT,
                formModel: {},
                hiddenFormModel: {},
                selectedFile: null,
                isFormValid: false,
                isFormDirty: false,
                isFormPopulated: false,
                rawLoadingState: {
                    state: LOADING_PRISTINE
                },
                updateLoadingState: {
                    state: LOADING_PRISTINE,
                    name: 'Upload',
                    progress: 0,
                },
                publishLoadingState: {
                    state: LOADING_PRISTINE,
                    name: 'Publish'
                },
                draftLoadingState: {
                    state: LOADING_PRISTINE,
                    name: 'Draft'
                },
                archiveLoadingState: {
                    state: LOADING_PRISTINE,
                    name: 'Archive'
                },
                addLoadingState: {
                    state: LOADING_PRISTINE,
                    progress: 0,
                },
                snackBar: {
                    isShowing: false,
                    text: '',
                    color: 'info',
                    timeout: 6000
                },
                trimData: trimDataConstructor(),
                stitchingData: stitchDataConstructor(),
                expandedIdx: null,
            }
        },
        computed: {
            contentType() {
                return this.$store.state.media.spaceAssetContentType
            },
            fields() {
                if (this.$store.state.media.spaceAssetContentType) {
                    return this.$store.state.media.spaceAssetContentType.fields.filter(helpers.excludeMediaFields)
                } else {
                    return []
                }
            },
            mappedFields() {
                return this.fields.map(field => {
                    const formModelFieldRef = this.formModel[field.identifier]
                    const isTypeShortText = field.type === TYPE_TEXT_SHORT
                    const isTypeLongText = field.type === TYPE_TEXT_LONG
                    const isTypeBoolean = field.type === TYPE_BOOLEAN
                    const isTypeNumber = field.type === TYPE_NUMBER
                    const isTypeDatetime = field.type === TYPE_DATETIME
                    const isTypeLocation = field.type === TYPE_LOCATION
                    const isTypeReference = field.type === TYPE_REFERENCE

                    let isFieldValid = false
                    let onValidationStateChange = () => {

                    }
                    if (formModelFieldRef) {
                        isFieldValid = formModelFieldRef.valid
                        onValidationStateChange = (newState) => {
                            formModelFieldRef.valid = newState
                        }
                    }

                    return {
                        field,
                        isTypeShortText,
                        isTypeLongText,
                        isTypeBoolean,
                        isTypeNumber,
                        isTypeDatetime,
                        isTypeLocation,
                        isTypeReference,
                        isFieldValid,
                        onValidationStateChange,
                        formModelFieldRef,
                    }
                })
            },
            title() {
                const identifier = this.getPrimaryDisplayIdentifier(this.contentType)
                let title = ''
                if (this.contentType) {
                    title += this.contentType.name
                    title += ' > '
                }
                if (this.formModel[identifier] && this.formModel[identifier].value) {
                    title += this.formModel[identifier].value
                } else {
                    title += 'Untitled'
                }
                if (this.isFormDirty) {
                    title += '*'
                }
                return title
            },
            isEditMode() {
                return this.$route.name === R_NAME_EDIT_MEDIA
            },
            computedLoadingState() {
                if (this.isEditMode) {
                    return this.rawLoadingState.state
                } else {
                    return LOADING_COMPLETED_SUCCESS
                }
            },
            isLoading() {
                return this.computedLoadingState === LOADING_STARTED
            },
            isEntireFormValid() {
                return !Object.keys(this.formModel).map(key => {
                    return this.formModel[key].valid
                }).some(validationResult => {
                    return !validationResult
                }) && (this.selectedFile || this.isEditMode)
            },
            statusCssString() {
                return helpers.cssComputeStatusColor(this.status)
            },
            isStatusNotPublished() {
                return this.status !== PUBLISHED_TEXT
            },
            isStatusPublishLoading() {
                return this.publishLoadingState.state === LOADING_STARTED
            },
            isPublishButtonDisabled() {
                return this.publishLoadingState.state === LOADING_STARTED || !this.isEntireFormValid
            },
            isStatusNotDraft() {
                return this.status !== DRAFT_TEXT
            },
            isStatusDraftLoading() {
                return this.draftLoadingState.state === LOADING_STARTED
            },
            isDraftButtonDisabled() {
                return this.draftLoadingState.state === LOADING_STARTED || !this.isEntireFormValid
            },
            isStatusNotArchive() {
                return this.status !== ARCHIVED_TEXT
            },
            isStatusArchiveLoading() {
                return this.archiveLoadingState.state === LOADING_STARTED
            },
            isArchiveButtonDisabled() {
                return this.archiveLoadingState.state === LOADING_STARTED || !this.isEntireFormValid
            },
            isUpdateLoadingStateLoading() {
                return this.updateLoadingState.state === LOADING_STARTED
            },
            isUpdateButtonDisabled() {
                return this.updateLoadingState.state === LOADING_STARTED || !this.isEntireFormValid || !this.isFormDirty
            },
            isUpdateProgressCompleted() {
                return this.updateLoadingState.progress !== 100
            },
            isAddLoadingStateLoading() {
                return this.$store.state.media.createAssetState.loadingState === LOADING_STARTED
            },
            isAddButtonDisabled() {
                return this.addLoadingState.state === LOADING_STARTED || !this.isEntireFormValid
            },
            isMediaPipelineEnabled() {
                return process.env.VUE_APP_MEDIA_PIPELINE_ENABLED
            },
            mimeTypeOfSelectedFile() {
                let m = ''
                if (this.isEditMode) {
                    m = this.hiddenFormModel.media_type.value
                } else {
                    if (this.selectedFile) {
                        m = this.selectedFile.type
                    }
                }
                return m
            },
            mimeCategoryOfSelectedFile() {
                if (this.mimeTypeOfSelectedFile.match('image.*')) {
                    return ASSET_CATEGORY_IMAGE
                } else if (this.mimeTypeOfSelectedFile.match('audio.*')) {
                    return ASSET_CATEGORY_AUDIO
                } else if (this.mimeTypeOfSelectedFile.match('video.*')) {
                    return ASSET_CATEGORY_VIDEO
                } else if (this.mimeTypeOfSelectedFile.match('application/pdf')) {
                    return ASSET_CATEGORY_PDF
                } else {
                    return null
                }
            },
            inputAcceptsArray() {
                const arr = []
                if (this.mimeTypeOfSelectedFile) {
                    arr.push(this.mimeTypeOfSelectedFile)
                }
                return arr
            },
            isTrimUIShowing() {
                return this.mimeCategoryOfSelectedFile === ASSET_CATEGORY_AUDIO
                    || this.mimeCategoryOfSelectedFile === ASSET_CATEGORY_VIDEO
            },
            isStitchingUIShowing() {
                return this.mimeCategoryOfSelectedFile === ASSET_CATEGORY_VIDEO && !this.isEditMode
            },
            trimInputStartAsNumber() {
                return Number(this.trimData.start)
            },
            trimInputEndAsNumber() {
                return Number(this.trimData.end)
            },
            isTrimFlowActive() {
                return this.expandedIdx === 0
                    && (this.trimInputStartAsNumber > 0 || this.trimInputEndAsNumber > 0)
            },
            isStitchingFlowActive() {
                return this.expandedIdx === 1 && this.stitchingData.selectedFiles.length > 0
            },
            createAssetProgress() {
                return this.$store.state.media.createAssetProgress
            },
            isAddProgressCompleted() {
                return this.createAssetProgress !== 100
            },
        },
        watch: {
            contentType() {
                this.buildFormModel()
            },
            '$route'() {
                this.trimData = trimDataConstructor()
                this.stitchingData = stitchDataConstructor()
                this.selectedFile = null
            },
        },

        methods: {
            buildFormModel() {
                if (this.contentType) {
                    let savedState = null
                    if (this.$store.state.nestedCreateObjectStack.length > 0) {
                        const topState = this.$store.getters[GET_NESTED_CREATION_STACK_TOP]
                        if (topState.routeSnapshot.fullPath === this.$route.fullPath) {
                            this.$store.commit(REMOVE_NESTED_CREATION_STACK_TOP)
                            savedState = topState.formModel
                        }
                    }
                    this.cleanFormModel()

                    this.fields.forEach(field => {
                        if (!this.formModel[field.identifier]) {
                            this.$set(this.formModel, field.identifier, {})
                            switch (field.type) {
                                case TYPE_TEXT_SHORT:
                                    this.$set(this.formModel[field.identifier], 'value', savedState ? savedState[field.identifier].value : '')
                                    this.$set(this.formModel[field.identifier], 'valid', savedState ? savedState[field.identifier].valid : false)
                                    break
                                case TYPE_TEXT_LONG:
                                    this.$set(this.formModel[field.identifier], 'value', savedState ? savedState[field.identifier].value : '')
                                    this.$set(this.formModel[field.identifier], 'valid', savedState ? savedState[field.identifier].valid : false)
                                    break
                                case TYPE_BOOLEAN:
                                    this.$set(this.formModel[field.identifier], 'value', savedState ? savedState[field.identifier].value : false)
                                    this.$set(this.formModel[field.identifier], 'valid', true)
                                    break
                                default:
                                    this.$set(this.formModel[field.identifier], 'value', savedState ? savedState[field.identifier].value : null)
                                    this.$set(this.formModel[field.identifier], 'valid', savedState ? savedState[field.identifier].valid : false)
                                    break
                            }
                        }
                    })
                    this.populateFormModel()
                }

            },
            cleanFormModel() {
                for (const key of Object.keys(this.formModel)) {
                    this.$delete(this.formModel[key], 'value')
                    this.$delete(this.formModel[key], 'valid')
                    this.$delete(this.formModel, key)
                }
            },
            populateFormModel() {
                if (this.isEditMode) {
                    this.rawLoadingState.state = LOADING_STARTED
                    return http.get(`api/management/spaces/${this.$store.state.spaceMetadata.id}/entries/${this.assetsContentType}/${this.$route.params.id}`)
                        .then(results => {
                            this.rawLoadingState.state = LOADING_COMPLETED_SUCCESS
                            this.status = results.data.status
                            const nonMediaFields = results.data.fields.filter(helpers.excludeMediaFields)
                            for (const key of Object.keys(nonMediaFields)) {
                                this.formModel[nonMediaFields[key].identifier].value = helpers.castField(nonMediaFields[key])
                            }
                            const mediaFields = results.data.fields.filter(helpers.includeMediaFields)
                            for (const key of Object.keys(mediaFields)) {
                                this.hiddenFormModel[mediaFields[key].identifier] = {
                                    value: mediaFields[key].value
                                }
                            }
                            this.existingAsset = results.data
                            this.isFormPopulated = true
                        }).catch(err => {
                            this.rawLoadingState.state = LOADING_COMPLETED_FAILURE
                            console.log(err)
                        })
                }
            },
            getPrimaryDisplayIdentifier: helpers.getPrimaryDisplayIdentifier,
            getPrimaryDisplayName: helpers.getPrimaryDisplayName,
            touchState() {
                this.isFormDirty = true
            },
            onFileInputChange(fileObj) {
                this.selectedFile = fileObj
                const identifier = this.getPrimaryDisplayIdentifier(this.contentType)
                if (this.formModel[identifier] && this.formModel[identifier].value === '') {
                    this.formModel[identifier].value = this.selectedFile.name
                }
            },
            toggleStatusState(intendedStatusString) {
                const mergedFormModel = Object.assign({}, this.formModel, this.hiddenFormModel)
                const exitObj = convertToOutgoingEntry(mergedFormModel, this.$route.params.id, intendedStatusString)

                let loadingStateReference = null;
                switch (intendedStatusString) {
                    case PUBLISHED_TEXT:
                        loadingStateReference = this.publishLoadingState
                        break
                    case DRAFT_TEXT:
                        loadingStateReference = this.draftLoadingState
                        break
                    case ARCHIVED_TEXT:
                        loadingStateReference = this.archiveLoadingState
                        break
                    default:
                        loadingStateReference = this.publishLoadingState
                        break
                }
                this.executeUpdate(loadingStateReference, exitObj)
            },
            async updateEntry() {
                const mergedFormModel = Object.assign({}, this.formModel, this.hiddenFormModel)
                const exitObj = convertToOutgoingEntry(mergedFormModel, this.$route.params.id, this.status)
                this.updateLoadingState.state = LOADING_STARTED
                if (this.isTrimFlowActive) {
                    const newTrimmedAsset = await this.createdTrimmedAssetFromExistingAsset(exitObj);
                    await this.$store.dispatch(A_ARCHIVE_ASSET, {entry: newTrimmedAsset})
                    exitObj.fields = newTrimmedAsset.fields;
                }
                this.executeUpdate(this.updateLoadingState, exitObj)
            },
            async createdTrimmedAssetFromExistingAsset(existingAsset) {
                const durationField = existingAsset.fields.find(field => {
                    return field.identifier === 'duration'
                })
                const duration = Number(durationField.value)
                const body = {
                    entry: existingAsset.id,
                    start: this.trimInputStartAsNumber,
                    duration: duration - this.trimInputEndAsNumber - this.trimInputStartAsNumber
                }
                const newTrimmedAssetState = await this.$store.dispatch(A_TRIM_ASSET, body)
                const newTrimmedAsset = newTrimmedAssetState.data;
                return newTrimmedAsset
            },
            executeUpdate(loadingStateReference, exitObj) {
                const thisComponent = this
                const formData = new FormData()
                formData.append('entry', JSON.stringify(exitObj))
                if (this.selectedFile) {
                    formData.append('file', this.selectedFile)
                }

                loadingStateReference.state = LOADING_STARTED
                return http.post(`api/management/spaces/${this.$store.state.spaceMetadata.id}/assets/${this.$route.params.id}`, formData, {
                    onUploadProgress: function (progressEvent) {
                        if (progressEvent.lengthComputable) {
                            thisComponent.updateLoadingState.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }
                    }
                }).then(results => {
                    this.existingAsset = results.data
                    this.status = results.data.status
                    this.$refs['file-selector'].reset()
                    loadingStateReference.state = LOADING_COMPLETED_SUCCESS
                    this.isFormDirty = false
                    this.trimData = trimDataConstructor()
                    this.showSnackBar(`${loadingStateReference.name} complete.`, LOADING_COMPLETED_SUCCESS)

                    this.$store.dispatch(LOAD_SPACE_CONTENT, {
                        identifier: 'asset'
                    }).then(results2 => {
                    })
                }).catch(err => {
                    loadingStateReference.state = LOADING_COMPLETED_FAILURE
                    this.showSnackBar(`${loadingStateReference.name} failed.`, LOADING_COMPLETED_FAILURE)
                    console.log(err)
                })

            },
            pushNestedCreationObjectAndNavigate(contentTypeIdentifier) {
                this.$store.commit(PUSH_NESTED_CREATION_OBJECT, {
                    formModel: this.formModel,
                    routeSnapshot: lodash.pick(['fullPath', 'name', 'params', 'path'], this.$route),
                    contentTypeIdentifier: contentTypeIdentifier,
                })
                this.$router.push({
                    name: R_NAME_ADD_ENTRY,
                    params: {contentTypeIdentifier: contentTypeIdentifier}
                })
            },
            showSnackBar(text, status) {
                this.snackBar.text = text
                switch (status) {
                    case LOADING_COMPLETED_SUCCESS:
                        this.snackBar.color = SNACKBAR_COLOR_SUCCESS
                        break
                    case LOADING_COMPLETED_FAILURE:
                        this.snackBar.color = SNACKBAR_COLOR_ERROR
                        break
                    default:
                        this.snackBar.color = SNACKBAR_COLOR_INFO
                        break
                }
                this.snackBar.isShowing = true
            },
            onPublishButtonClick() {
                this.toggleStatusState(PUBLISHED_TEXT)
            },
            onDraftButtonClick() {
                this.toggleStatusState(DRAFT_TEXT)
            },
            onArchiveButtonClick() {
                this.toggleStatusState(ARCHIVED_TEXT)
            },
            onStitchingUIFileInputChange(fileObjs) {
                this.stitchingData.selectedFiles = fileObjs.map(fileObj => {
                    const ref = mediaRefConstructor()
                    ref.fileRef = fileObj
                    return ref
                })
            },
            async onAddAssetClick() {
                // Now that the add entry has been factored into a couple lines, this flow should be factored into 3
                // separate mediaStore actions, with their own corresponding states, so they are not all relying on the
                // createAssetState

                // The initial entry needs to be added in all cases, so go ahead and do it first
                const entry = convertToOutgoingEntry(this.formModel)
                const newCreateState = await this.$store.dispatch(A_CREATE_ASSET, {entry, file: this.selectedFile})
                if (newCreateState.loadingState === LOADING_COMPLETED_SUCCESS) {
                    if (this.isTrimFlowActive) {
                        const durationField = newCreateState.data.fields.find(field => {
                            return field.identifier === 'duration'
                        })
                        if (durationField) {
                            const duration = Number(durationField.value)
                            const body = {
                                entry: newCreateState.data.id,
                                start: this.trimInputStartAsNumber,
                                duration: duration - this.trimInputEndAsNumber - this.trimInputStartAsNumber
                            }
                            const trimmedAssetState = await this.$store.dispatch(A_TRIM_ASSET, body)
                            await this.$store.dispatch(A_ARCHIVE_ASSET, {entry: newCreateState.data})
                            this.afterAddFlow(trimmedAssetState)

                        }
                    } else if (this.isStitchingFlowActive) {
                        const entryIds = [newCreateState.data.id]
                        for (const datum of this.stitchingData.selectedFiles) {
                            const formModel = {
                                name: {
                                    value: datum.fileRef.name
                                }
                            }
                            const entry = convertToOutgoingEntry(formModel)
                            const newCreateState = await this.$store.dispatch(A_CREATE_ASSET, {
                                entry,
                                file: datum.fileRef
                            })
                            if (newCreateState.loadingState === LOADING_COMPLETED_SUCCESS) {
                                entryIds.push(newCreateState.data.id)
                            } else {
                                break
                            }
                        }
                        if (newCreateState.loadingState === LOADING_COMPLETED_SUCCESS) {
                            const newStitchAssetsState = await this.$store.dispatch(A_STITCH_ASSETS, {entryIds})
                            this.afterAddFlow(newStitchAssetsState)
                        } else {
                            this.afterAddFlow(newCreateState)
                        }
                    } else {
                        this.afterAddFlow(newCreateState)
                    }
                }

            },
            async afterAddFlow(newEntryState) {
                await this.$store.dispatch(LOAD_SPACE_CONTENT, {
                    identifier: this.assetsContentType
                })
                if (newEntryState.loadingState === LOADING_COMPLETED_SUCCESS) {
                    this.isFormDirty = false
                    this.isFormPopulated = true
                    this.showSnackBar('Media added.', LOADING_COMPLETED_SUCCESS)

                    if (this.$store.state.nestedCreateObjectStack.length === 0) {
                        this.$router.replace(
                            {
                                name: R_NAME_EDIT_MEDIA,
                                params: {
                                    id: newEntryState.data.id,
                                }
                            })
                    } else {
                        this.$store.commit(SET_REFERENCE_NESTED_CREATION_OBJECT_STACK_TOP, newEntryState.data)
                        const topOfStack = this.$store.getters[GET_NESTED_CREATION_STACK_TOP]
                        this.$router.replace(
                            {
                                name: topOfStack.routeSnapshot.name,
                                params: topOfStack.routeSnapshot.params
                            })
                    }
                } else if (newEntryState.loadingState === LOADING_COMPLETED_FAILURE) {
                    this.showSnackBar('Adding entry failed.', LOADING_COMPLETED_FAILURE)
                }
            }
        },
        created() {
            if (this.contentType) {
                this.buildFormModel()
            }
        },

    }
</script>

<style scoped lang="scss">
    @import "../meta";

    $offset-height: 68px;
    .content-toolbar {
        position: fixed;
        margin-bottom: 4px;
        z-index: 4;

        .back-button {
            height: 100%;
            margin: 0 1em 0 0;
        }
    }

    .content-container {
        display: flex;
        margin: $offset-height 0 0 0;
        height: calc(100% - 68px);
        justify-content: center;

        .form-container {
            margin: 0 300px 0 0;
        }

        .fields-container {
            max-width: 1000px;
            min-width: 600px;
        }

        .crud-sidebar-container {
            height: 100%;
            position: fixed;
            right: 0;
        }

        .crud-sidebar {
            z-index: 3;
        }
    }

    .right-side-bar {
        padding: 1em;
    }

    .icon-status {
        margin: 0 .75em 0 0;
    }

    .field-container-1 {
        margin: 2em 0;

        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .text-long-header {
        font-size: 14px;
        margin: 0 0 1em 0;
    }

    .regular-type-header {
        font-size: 14px;

        .input-group {
            padding: 0px;
        }
    }

    .hint-text {
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;

        &.custom-validation-error-text {
            color: $error
        }
    }

    .switch-content {
        display: flex;
        align-items: center;
    }

    .icon-spacer {
        width: 0.5em;
    }

    .linked-entry {
        font-weight: bold;
        $border-width: 1px;
        border-left: $border-width solid $accent;
        margin: 13px 0 0 0;
        padding: 0 0 0 4px;
    }

    .datetime-pickers-container {
        display: flex;

        .date-picker-container {
            margin: 0 1em 0 0;
        }
    }

    .file-field-data-container {
        margin: 1em 0;

        .data-table-thumbnail {
            $size: 30px;
            max-height: $size;
            max-width: $size;
            vertical-align: middle;
            margin: 0 1em 0 0;
        }

        .category-icon {
            margin: 0 .5em 0 0;
        }

        a.file-field-link {
            color: blue;
        }
    }

    .dropzone-comp {
        /*margin: 2em 0 0 0;*/
    }

    .trim-ui {
        display: flex;
        padding: 1em;

        > div {
            flex-grow: 1;

            &:first-child {
                padding: 0 1em 0 0;
            }

            &:last-child {
                padding: 0 0 0 1em;
            }
        }
    }

    .stitch-ui {
        padding: 1em;
    }
</style>
